import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-bold-trash',
  imports: [],
  templateUrl: './icon-bold-trash.html',
  standalone: true,
  styleUrl: './icon-bold-trash.css'
})
export class IconBoldTrash {
  @Input() color: string = '#E41D2F';
  @Input() size: string = '24px';
}
